import * as React from 'react';
import { ILinkProps, PikLink as PikLinkPure } from '../../ui/pik_link/pik_link';
import { getSearch, LocationDescriptor, PlainLocationDescriptor } from '../../utils/location';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../types/redux';
import { changeHash } from '../../actions/location';
import { Region } from '../../utils/regions';
import { regionChange } from '../../actions/filter';

interface IInjectedProps {
  changeHash(newHash: string): void;
  regionChange(region: Region): void;
  location: PlainLocationDescriptor;
}

interface IOwnProps extends Partial<ILinkProps> {
  to: LocationDescriptor;
  mergeQuery?: boolean;
}

type Props = IOwnProps & IInjectedProps;

class PikLinkComponent extends React.PureComponent<React.PropsWithChildren<Props>, object> {
  public render() {
    const { location } = this.props;
    const search = location.query ? getSearch(location) : '';
    const hash = location.hash ? `#${location.hash}` : '';
    const href = search + hash;

    return <PikLinkPure {...this.props} href={href} onClick={this.onClick} />;
  }

  private onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (this.props.to.query && this.props.to.query.location) {
      this.props.regionChange(this.props.to.query.location as Region);
    }
    this.props.changeHash(this.props.to.hash || '');
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };
}

export const PikLink = connect(
  (state: IApplicationState) => ({
    location: state.location,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      changeHash: (newHash: string) => {
        dispatch(changeHash(newHash));
      },
      regionChange: (region: Region) => {
        dispatch(regionChange(region));
      },
    };
  },
)(PikLinkComponent);
